import parsePostPath from './parsePostPath';
import safeParseUrl from '../../utils/url/safeParseUrl';

export const isOrganizationOrigin = (url: URL) => {
  const customDomains = [
    window.__slab.ORG_HOST,
    window.__slab.PUBLIC_ORG.effectiveHost,
  ];

  return customDomains.some((host) => url.origin.endsWith(host));
};

function matchCurrentUrl({
  target,
  currentUrl,
}: {
  target: string;
  currentUrl: string;
}): {
  hasCurrentPostId: boolean;
  hasMatchingOrigin: boolean;
} {
  const parsedCurrent = safeParseUrl(currentUrl);
  const parsedTarget = safeParseUrl(target, currentUrl);

  if (parsedTarget == null || parsedCurrent == null) {
    return {
      hasCurrentPostId: false,
      hasMatchingOrigin: false,
    };
  }

  const hasMatchingOrigin =
    parsedTarget.origin === parsedCurrent.origin ||
    isOrganizationOrigin(parsedTarget);

  if (parsedTarget.pathname === parsedCurrent.pathname) {
    return {
      hasCurrentPostId: true,
      hasMatchingOrigin,
    };
  }

  const parsedTargetPath = parsePostPath(parsedTarget.pathname);
  const parsedCurrentPath = parsePostPath(parsedCurrent.pathname);

  return {
    hasCurrentPostId:
      parsedTargetPath && parsedCurrentPath
        ? parsedTargetPath.id === parsedCurrentPath.id
        : false,
    hasMatchingOrigin,
  };
}

export default matchCurrentUrl;
